import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import LoadBoard from "./components/LoadBoard";
import About from "./components/About";
import Reviews from "./components/Reviews";
import ServiceReviews from "./components/ServiceReviews";
import WebPackages from "./components/WebPackages";
import WebsiteIntake from "./components/WebsiteIntake";
import Brokers from "./components/Brokers";
import Careers from "./components/Careers";
import WelcomeBack from "./components/WelcomeBack";
import ArcadeCTA from "./components/ArcadeCTA";
import FmcsaFiling from "./components/FmcsaFiling";
import Contact from "./components/Contact";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import AuthPage from "./pages/AuthPage";
import Portal from "./pages/Portal";
import Admin from "./pages/Admin";
import Training from "./pages/Training";
import Games from "./pages/Games";
import Certificate from "./pages/Certificate";
import ProtectedRoute from "./components/ProtectedRoute";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

const MarketingHome = () => (
  <div className="App" id="top">
    <Header />
    <WelcomeBack />
    <main>
      <Hero />
      <div className="chevron-divider"></div>
      <Services />
      <LoadBoard />
      <About />
      <Reviews />
      <ServiceReviews />
      <WebPackages />
      <WebsiteIntake />
      <Brokers />
      <ArcadeCTA />
      <Careers />
      <FmcsaFiling />
      <Contact />
    </main>
    <Newsletter />
    <Footer />
    <ChatWidget />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MarketingHome />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/signup" element={<AuthPage mode="signup" />} />
          <Route path="/portal" element={<ProtectedRoute><Portal /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
          <Route path="/training" element={<Training />} />
          <Route path="/games" element={<Games />} />
          <Route path="/training/certificate" element={<Certificate />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
